import { Form, FormBuilder, PageLoader, useLookup } from "@redriver/cinnamon";
import React from "react";
import { Button } from "semantic-ui-react";
import { agreeToTerms } from "./actions";
import { useHistory } from "react-router-dom";
import { dashboardDetailsLookup } from "features/Dashboard/lookups";
import { SystemRoutes } from "constants/routes";

const TermsAndConditions = () => {
  const history = useHistory();
  const [{ response, loading }, resetLookup] = useLookup(
    dashboardDetailsLookup
  );

  if (loading) {
    return <PageLoader />;
  }

  const alreadyAgreed = response?.hasAcceptedTerms == true;

  return (
    <FormBuilder
      initialData={{
        termsAndConditions: alreadyAgreed,
      }}
      submitAction={agreeToTerms}
      onSubmitted={() => {
        resetLookup();
        history.push(SystemRoutes.Dashboard);
      }}
      renderForm={(formProps, state, events) => (
        <Form {...formProps}>
          <p>
            Please read the{" "}
            <a
              target="_blank"
              href="https://selectschoolskiing.com/school-ski-trips-booking-and-planning/terms-conditions"
            >
              Terms of Contract here
            </a>
            .
          </p>

          <Form.Checkbox
            field="termsAndConditions"
            label="I have read, understood and accept the terms of contract"
            disabled={alreadyAgreed}
          />

          {!alreadyAgreed ? (
            <Button
              positive
              onClick={events.onSubmit}
              disabled={!formProps.value.termsAndConditions}
              loading={state.submitting}
              className="rounded-button"
            >
              Confirm
            </Button>
          ) : (
            <p>You have already agreed to the Terms & Conditions.</p>
          )}
        </Form>
      )}
    />
  );
};

export default TermsAndConditions;
